const validations ={
    quickLinks: {
        max: 20,
        min: 3
    }
}

export {
    validations
}